import './legacy.js'

// Modeled after navigation moving
jQuery('header .col.span_9.col_last').first().attr('id', 'naviMain')
;(function checkAndMoveNav() {
  if (jQuery('#naviMain nav').length) {
    jQuery('#naviMain nav').appendTo('#naviContainer')
  } else {
    setTimeout(checkAndMoveNav, 500)
  }
})()

jQuery('#naviContainer')
  .parent()
  .append(jQuery('#language-switcher').get(0).content.cloneNode(true))
